import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const useLegalReportStateManager = () => {
  return useOpenedStateManager('LEGAL_REPORT');
};
